export default __webpack_public_path__ + "static/media/creativey.5403f68d.png";